import React from 'react';

export const uploadSteps = () => {
  return (
    <div className="card padding-normal">
      <div className="card-title">数据应用流程</div>
      <div className="data-upload leads">
        <div className="step">
          <div className="step-icon icon-data-upload margin-t-10 margin-b-10" />
          <div className="step-name"> 1. 设置上报规则</div>
          <div className="step-detail margin-t-10">支持按照标签及线索条件进行组合设置上报规则</div>
        </div>
        <div className="icon-next-step margin-t-30" />
        <div className="step">
          <div className="step-icon icon-data-usage margin-t-10 margin-b-10" />
          <div className="step-name">2. 在投放端应用</div>
          <div className="step-detail margin-t-10">上报数据将作用于优化线索有效率、付费率并在投放端报表中统计展示，减少恶意人群，优化广告投放</div>
        </div>
      </div>
    </div>
  );
};
